import _isEmpty from 'lodash/isEmpty';

export function getValidationMessage(formData) {
  const { name: modifierSetName, modifiers } = formData || {};

  if (_isEmpty(modifierSetName)) {
    return 'Please enter a modifier set name.';
  }

  if (_isEmpty(modifiers)) {
    return 'Please add at least one modifier.';
  }

  const modifierErrors = modifiers.map(({ name: modifierName }) => !!modifierName);

  if (modifierErrors.includes(false)) {
    return 'Please enter a modifier name.';
  }

  return true;
}
